query GetLandingPageStarters {
    pageStarters {
        id
        name
        thumbnailUrl
        categoryId
        categoryName
        backgroundColor
    }
}
